document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.getElementById('StickyAddToCart');
  if (!stickyBar) return;
  const stickyButton = stickyBar.querySelector('[data-bbs-sticky-submit]');
  const fallbackLink = stickyBar.querySelector('[data-bbs-sticky-fallback]');
  const firstFoldHeight = window.innerHeight;
  let delegating = false;

  function getMainPurchase() {
    const main = document.getElementById('MainContent');
    const productInfo = main?.querySelector('product-info[id^="MainProduct-"][data-update-url="true"]');
    if (!productInfo || productInfo.dataset.productId !== stickyBar.dataset.productId) return null;
    const form = document.getElementById(`product-form-${productInfo.dataset.section}`);
    if (!form || !productInfo.contains(form) || form.dataset.type !== 'add-to-cart-form') return null;
    const button = form.querySelector('button[type="submit"][name="add"]');
    const variant = form.elements.namedItem('id');
    return button && variant ? { productInfo, form, button, variant } : null;
  }

  function isBusy(purchase) {
    return Boolean(purchase.productInfo.pendingRequestUrl)
      || purchase.productInfo.getAttribute('aria-busy') === 'true'
      || purchase.button.getAttribute('aria-disabled') === 'true'
      || purchase.button.getAttribute('aria-busy') === 'true'
      || purchase.button.classList.contains('loading');
  }

  function isBlocked(purchase) {
    return delegating || purchase.button.disabled || isBusy(purchase)
      || purchase.variant.disabled || !purchase.variant.value;
  }

  function syncPurchaseControls() {
    if (!stickyButton || !fallbackLink) return;
    const purchase = getMainPurchase();
    stickyButton.hidden = !purchase;
    stickyButton.classList.toggle('hidden', !purchase);
    fallbackLink.hidden = Boolean(purchase);
    fallbackLink.classList.toggle('hidden', Boolean(purchase));
    fallbackLink.setAttribute('href', purchase ? `#${purchase.productInfo.id}` : '#MainContent');
    if (!purchase) return;
    const busy = isBusy(purchase);
    stickyButton.disabled = isBlocked(purchase);
    stickyButton.setAttribute('aria-controls', purchase.form.getAttribute('id'));
    stickyButton.setAttribute('aria-busy', String(busy));
    stickyButton.classList.toggle('loading', purchase.button.classList.contains('loading'));
    stickyButton.querySelector('.loading__spinner')?.classList.toggle('hidden', !busy);
    const label = purchase.button.querySelector('span');
    const stickyLabel = stickyButton.querySelector('span');
    if (label && stickyLabel && stickyLabel.textContent !== label.textContent) {
      stickyLabel.textContent = label.textContent;
    }
  }

  stickyButton?.addEventListener('click', function () {
    const purchase = getMainPurchase();
    if (!purchase || isBlocked(purchase)) {
      syncPurchaseControls();
      return;
    }
    delegating = true;
    stickyButton.disabled = true;
    try {
      purchase.button.click();
    } finally {
      delegating = false;
      syncPurchaseControls();
    }
  });

  function syncStickyBar() {
    const shouldShow = window.scrollY > firstFoldHeight;
    stickyBar.classList.toggle('hidden', !shouldShow);

    const height = shouldShow ? Math.ceil(stickyBar.getBoundingClientRect().height) : 0;
    const visible = shouldShow && height > 0;
    document.body.classList.toggle('bbs-sticky-purchase-visible', visible);
    if (visible) {
      document.documentElement.style.setProperty('--bbs-sticky-purchase-height', `${height}px`);
    } else {
      document.documentElement.style.removeProperty('--bbs-sticky-purchase-height');
    }
  }

  const main = document.getElementById('MainContent');
  if (main && typeof MutationObserver !== 'undefined') {
    new MutationObserver((records) => {
      if (records.some((record) => !stickyBar.contains(record.target))) syncPurchaseControls();
    }).observe(main, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class', 'data-product-id', 'data-section'],
    });
  }
  window.addEventListener('scroll', syncStickyBar, { passive: true });
  window.addEventListener('resize', syncStickyBar);
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(syncStickyBar).observe(stickyBar);
  }
  syncPurchaseControls();
  syncStickyBar();
});
